// Búsqueda de eventos de la cabecera: el texto vive en la URL (`/events?q=…`) para que
// la cabecera (que se remonta al cambiar de pantalla) y el listado compartan estado sin redux.
export const EVENTS_LIST_PATH = '/events';
export const EVENTS_SEARCH_PARAM = 'q';

export const readEventsSearch = (location) =>
    new URLSearchParams(location?.search || '').get(EVENTS_SEARCH_PARAM) || '';

export const eventsSearchLocation = (q) => ({
    pathname: EVENTS_LIST_PATH,
    search: q ? `?${EVENTS_SEARCH_PARAM}=${encodeURIComponent(q)}` : '',
});

// Compara sin acentos ni mayúsculas: «Marató» encuentra «maraton».
const fold = (s) => (s || '').toString().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();

export const matchesEventsSearch = (q, ...fields) => {
    const needle = fold(q);
    if (!needle) return true;
    return fields.some(f => fold(f).includes(needle));
};
